module.exports = __webpack_public_path__ + "static/media/at.349da5c5.jpeg";